export function safeUrl(value,{image=false,optional=true}={}){
  if(!value&&optional)return '';
  if(image&&/^\/images\/[a-zA-Z0-9_./-]+$/.test(value))return value;
  let u;try{u=new URL(value);}catch{throw Error('Enter a complete https:// URL.');}
  if(u.protocol!=='https:'||u.username||u.password)throw Error('Only secure https:// URLs are allowed.');
  return u.href;
}
export function videoInfo(value,platform){
  const url=safeUrl(value,{optional:false});const u=new URL(url);const host=u.hostname.toLowerCase();
  if(platform==='YouTube'){
    let id='';if(host==='youtu.be')id=u.pathname.split('/')[1];
    else if(['youtube.com','www.youtube.com','m.youtube.com'].includes(host))id=u.searchParams.get('v')||(/^\/(?:embed|shorts|live)\/([^/]+)/.exec(u.pathname)||[])[1];
    if(!/^[\w-]{11}$/.test(id||''))throw Error('Enter a valid YouTube video link, not a channel or playlist link.');
    return {videoId:id,embedUrl:`https://www.youtube-nocookie.com/embed/${id}`,autoThumbnail:`https://i.ytimg.com/vi/${id}/hqdefault.jpg`};
  }
  if(platform==='Facebook'&&['facebook.com','www.facebook.com','m.facebook.com','fb.watch'].includes(host)&&u.pathname!=='/')return {videoId:'',embedUrl:'',autoThumbnail:''};
  throw Error('Enter a YouTube video URL or an official Facebook video URL for the selected platform.');
}
export function eventExpired(event,now=new Date()){
  if(event.repeat&&event.repeat!=='none')return occurrenceDates(event,now).length===0;
  if(event.dates?.length)return event.dates.every(d=>eventExpired({...d,startDate:d.date,endDate:d.endDate||d.date,timezone:event.timezone},now));
  const date=event.endDate||event.startDate;const time=event.endTime||'23:59';
  // Compare in the event's timezone, independent of the visitor's timezone.
  const parts=Object.fromEntries(new Intl.DateTimeFormat('en-CA',{timeZone:event.timezone||'America/Los_Angeles',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(now).map(p=>[p.type,p.value]));
  return `${date}T${time}`<`${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
}
export function eventDates(event){return event.dates?.length?event.dates:[{date:event.startDate||'',startTime:event.startTime||'',endTime:event.endTime||'',endDate:event.endDate||''}];}
export function validateEventDates(dates){
 if(!Array.isArray(dates)||dates.length<1||dates.length>7)throw Error('Add between one and seven event dates.');
 const seen=new Set();
 for(const d of dates){
  if(!/^\d{4}-\d{2}-\d{2}$/.test(d.date)||!Number.isFinite(Date.parse(d.date))||new Date(d.date).toISOString().slice(0,10)!==d.date)throw Error('Choose a valid date for each session.');
  if(!/^([01]\d|2[0-3]):[0-5]\d$/.test(d.startTime)||(d.endTime&&(!/^([01]\d|2[0-3]):[0-5]\d$/.test(d.endTime)||(!(d.endDate&&d.endDate>d.date)&&d.endTime<=d.startTime))))throw Error('Choose a valid start time. If provided, the end time must be later than the start time.');
  if(d.endDate&&(!/^\d{4}-\d{2}-\d{2}$/.test(d.endDate)||!Number.isFinite(Date.parse(d.endDate))||new Date(d.endDate).toISOString().slice(0,10)!==d.endDate||d.endDate<d.date))throw Error('End date must be a valid date on or after the start date.');
  if(seen.has(d.date))throw Error('Use a different date for each session.');seen.add(d.date);
 }
 return dates.map(({date,startTime,endTime,endDate})=>({date,startTime,endTime:endTime||'',...(endDate?{endDate}:{})})).sort((a,b)=>a.date.localeCompare(b.date));
}
export function sortContent(items){return [...items].sort((a,b)=>(a.displayOrder||0)-(b.displayOrder||0)||(b.date||b.startDate||'').localeCompare(a.date||a.startDate||''));}

export const repeatLabels={daily:'Every day',weekly:'Every week',biweekly:'Every other week',monthly:'Every month',yearly:'Every year'};
export function occurrenceDates(event,now=new Date()){
 if(!repeatLabels[event.repeat])return eventDates(event);
 const result=[];
 for(const seed of eventDates(event)){
  if(!seed.date)continue;
  const base=new Date(seed.date+'T12:00:00Z');
  const duration=seed.endDate?Math.round((Date.parse(seed.endDate)-Date.parse(seed.date))/86400000):0;
  let added=0;
  for(let i=0;i<100000&&added<12;i++){
   const d=new Date(base);
   if(event.repeat==='monthly'){d.setUTCMonth(base.getUTCMonth()+i);if(d.getUTCDate()!==base.getUTCDate())continue;}
   else if(event.repeat==='yearly'){d.setUTCFullYear(base.getUTCFullYear()+i);if(d.getUTCMonth()!==base.getUTCMonth())continue;}
   else d.setUTCDate(base.getUTCDate()+i*({daily:1,weekly:7,biweekly:14}[event.repeat]));
   const date=d.toISOString().slice(0,10);
   if(event.repeatUntil&&date>event.repeatUntil)break;
   const endDate=new Date(d.getTime()+duration*86400000).toISOString().slice(0,10);
   const next={...seed,date,endDate:duration?endDate:''};
   if(eventExpired({startDate:date,endDate,endTime:seed.endTime,timezone:event.timezone},now))continue;
   result.push(next);added++;
  }
 }
 return result.sort((a,b)=>(a.date+a.startTime).localeCompare(b.date+b.startTime));
}

